import { useState, Children, type FunctionComponent, type PropsWithChildren,} from "react";
import { IconButton, } from "@bracket/react-icon-button";


import "./Drawer.scss";



export declare type DrawerProps = PropsWithChildren<{
	direction?: "up" | "down" | "left" | "right" | "vertical" | "horizontal";
	disabled?: boolean;
}>;



export const Drawer: FunctionComponent<DrawerProps> = ({
	direction = "down",
	disabled = false,
	children,
}) => {

	const classes = () => [ `drawer`, `drawer-${direction}`, open ? "open" : "closed", disabled ? "disabled" : false, ].filter(v => v).join(" ");
	const [ open, toggle, ] = useState(false);
	let Reveal: any = null;
	const renderables = Children.map(children, ( child: any, idx, ) => {
		if(child.type && child.type.name === (<DrawerOpen />).type.name) {
			Reveal = child;
			return null;
		}
		return child;
	});



	const onToggle = ( ) => toggle(!open);

	return (
		<div className={classes()}>
			<div className="open">
				<div className="contents">
					{ renderables }
					<div className="toggle" onClick={onToggle}>
						<IconButton icon="Chevron" />
					</div>
				</div>
			</div>
			<div className="revealed">
				{ open && Reveal }
			</div>
		</div>
	);

}


export const DrawerOpen: FunctionComponent<PropsWithChildren<{}>> = ({
	children,
}) => {
	const classes = [ `drawer-open` ].join(" ");

	return(
		<div className={classes}>
			{ children }
		</div>
	)
}
